var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.getCurrentRoute() + '/' + this.params.data.identifier}},[(_vm.params.value)?_c('span',[_vm._v(_vm._s(_vm.params.value))]):_c('span',[_vm._v("Vedi dettaglio")])])}
var staticRenderFns = []

export { render, staticRenderFns }